import React, { createContext, useContext, useRef } from 'react';
import { createPortal } from 'react-dom';
import { observer } from 'mobx-react-lite';
import { Div } from '@icecreamsocial/components';
import MainPane from '../MainPane';

// Create a context for the portal ref so that we can retrieve it throughout the app
const EditPaneContext = createContext({ portalRef: null });
EditPaneContext.displayName = 'EditPaneContext';

const useEditPanePortal = () => {
	return (children) => {
		const { portalRef } = useContext(EditPaneContext);
		return portalRef.current && createPortal(children, portalRef.current);
	};
};
const EditPanePortal = observer(({ children }) => {
	const renderPortal = useEditPanePortal();
	return renderPortal(children);
});

const EditPane = ({ children, ...rest }) => {
	const editPaneRef = useRef();
	return (
		<EditPaneContext.Provider value={{ portalRef: editPaneRef }}>
			<MainPane {...rest}>{children}</MainPane>
			<Div ref={editPaneRef} position="sticky" positionBottom="0" />
		</EditPaneContext.Provider>
	);
};
EditPane.displayName = 'InfluencerManager.EditPane';

EditPane.Controls = EditPanePortal;
EditPane.Controls.displayName = 'EditPane.Controls';

export default observer(EditPane);
